// extracted by mini-css-extract-plugin
module.exports = {"TopPanel":"Search_TopPanel__3SmdH","SearchBox":"Search_SearchBox__3f5ZE","ControlsBox":"Search_ControlsBox__1FduJ"};